"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "bg-white text-gray-900 border shadow-lg",
          success: "bg-white text-green-700 border-green-300",
          error: "bg-white text-red-700 border-red-300",
          info: "bg-white text-blue-700 border-blue-300",
          warning: "bg-white text-yellow-700 border-yellow-300",
        },
      }}
      style={
        {
          "--normal-bg": "#ffffff",
          "--normal-text": "#111827",
          "--normal-border": "#e5e7eb",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
